// extracted by mini-css-extract-plugin
export default {"root":"app-layout_root__qSWN5","main":"app-layout_main__LeVN-","content":"app-layout_content__yR7po"};